import { ApiError } from '../types/apiError'

/**
 * Texto exibido quando o pré-agendamento de portabilidade falha.
 *
 * A recusa de regra de negócio (HTTP 200 com `retorno: false`) chega com a
 * mensagem crua da API, só em português e sem orientar o cliente (ex.:
 * "Ativação não encontrada."). Nesse caso o texto sai do dicionário, com o
 * caminho de suporte. Os demais erros (422, 4xx/5xx, rede) seguem a regra
 * geral de `useApiErrorMessage`.
 */
export interface PortabilityErrorTexts {
  notScheduled: string
  failed: string
}

export function portabilityErrorMessage(
  erro: ApiError,
  textos: PortabilityErrorTexts,
  mensagemDeErro: (erro: ApiError, fallback?: string) => string
): string {
  if (erro.code === 'BUSINESS_RULE') return textos.notScheduled

  return mensagemDeErro(erro, textos.failed)
}
